import { TweenLite } from 'gsap/TweenLite';
import { ROOT_CLASS } from '@/scripts/constants';
import ScrollMagic from 'scrollmagic';
import 'animation.gsap';
import Controller from '@/scripts/utils/scrollmagic/controller';
import './scrollToTop.scss';

document.addEventListener('DOMContentLoaded', () => {
  const scrollToTop = document.createElement('div');
  const content = document.querySelector('.content');
  if (!content) return;

  scrollToTop.className = `${ROOT_CLASS} scroll-to-top`;
  scrollToTop.dataset.role = 'scroll-to-top';
  document.body.appendChild(scrollToTop);
  scrollToTop.addEventListener('click', () => {
    TweenLite.to(window, 0.8, { scrollTo: { y: 0, autoKill: false } });
  });

  new ScrollMagic.Scene({
    triggerElement: content,
    triggerHook: 'onLeave',
  })
    .setClassToggle(scrollToTop, 'is-active')
    .addTo(Controller);
});



// WEBPACK FOOTER //
// ./scripts/elements/scrollToTop/scrollToTop.js